package one.healthium.log_food.ui.navigation.find_food

import com.arkivanov.decompose.ComponentContext
import one.healthium.profile.ui.food.models.FoodUiModel

class DefaultFindFoodComponent(
    componentContext: ComponentContext,
    private val onFoodClicked: (FoodUiModel) -> Unit,
    private val onScanBarcode: suspend () -> String?,
) : FindFoodComponent, ComponentContext by componentContext {
    override fun onFoodClicked(food: FoodUiModel) {
        onFoodClicked.invoke(food)
    }

    override suspend fun onScanBarcode(): String? {
        return onScanBarcode.invoke()
    }
}